import { Input } from "antd";
import { type ChangeEvent, useState } from "react";

type Props = {
  value: string;
  onChange: (value?: string | null) => void;
  disabled?: boolean;
};

const InputColumn = ({ value, onChange, disabled }: Props) => {
  const [inputValue, setInputValue] = useState(value);

  return (
    <Input
      onBlur={() => onChange(inputValue)}
      disabled={disabled}
      style={{ width: "100%" }}
      onPressEnter={() => onChange(inputValue)}
      value={inputValue}
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.currentTarget.value;
        setInputValue(inputValue);
      }}
    />
  );
};

export default InputColumn;
